import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsFilterMenuButtons.module.scss";
import {FilterGenreDropdownMenu} from "../../../../modules/songs/filter-genre-dropdown-menu/FilterGenreDropdownMenu";
import {
  FilterDifficultyDropdownMenu
} from "../../../../modules/songs/filter-difficulty-dropdown-menu/FilterDifficultyDropdownMenu";
import {
  FilterFeaturesDropdownMenu
} from "../../../../modules/songs/filter-features-dropdown-menu/FilterFeaturesDropdownMenu";

export const SongsFilterMenuButtons: VoidFunctionComponent = () => {
  return <div className={s.songsFilterMenuButtons}>
    <FilterDifficultyDropdownMenu />
    <FilterGenreDropdownMenu />
    <FilterFeaturesDropdownMenu />
  </div>;
}
